import React from "react";
import PropTypes from "prop-types";
//Material imports
import withStyles from "@mui/styles/withStyles";
//Limitless imports
import { MessageClassificationForm } from "../../../../expert";
import CategoriseByResponseCode from "./categorise-by-response-code/CategoriseByResponseCode";
import CategoriseByTags from "./categorise-by-tags/CategoriseByTags";
import FeedbackByInput from "./feedback-by-input/FeedbackByInput";
import FeedbackByVoting from "./feedback-by-voting/FeedbackByVoting";
import ProductCodeSearch from "./product-code-search/ProductCodeSearch";
const COMPONENT_MAP = {
  "categorise-by-tags": CategoriseByTags,
  "categorise-by-codes": CategoriseByResponseCode,
  "feedback-by-input": FeedbackByInput,
  "feedback-by-vote": FeedbackByVoting,
  "product-code-search": ProductCodeSearch
};
const Classification = ({
  classes,
  message,
  messageResources,
  isReadOnly = false,
  aiReviewData,
  isAIDraftSelected
}) => {
  return /*#__PURE__*/React.createElement(MessageClassificationForm, null, ({
    classificationFieldList,
    fieldValues,
    fieldErrors,
    onFieldUpdate
  }) => {
    return /*#__PURE__*/React.createElement("div", {
      className: classes.classificationContainer
    }, classificationFieldList.length > 0 && classificationFieldList.map((action, index) => {
      const ClassificationOption = COMPONENT_MAP[action.component];
      let isMandatory = false;
      if (action.mandatoryKey) {
        isMandatory = message.conversationState.editorState[action.mandatoryKey];
      }
      return /*#__PURE__*/React.createElement("div", {
        key: index
      }, /*#__PURE__*/React.createElement(ClassificationOption, {
        action: action,
        actionIndex: `${index}`,
        message: message,
        messageResources: messageResources,
        onValueChange: onFieldUpdate,
        value: fieldValues[action.payloadKey],
        isMandatory: isMandatory,
        error: fieldErrors[action.payloadKey],
        isReadOnly: isReadOnly,
        aiReviewData: aiReviewData,
        isAIDraftSelected: isAIDraftSelected
      }));
    }));
  });
};
const styles = {
  classificationContainer: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    marginTop: 24,
    marginLeft: 1,
    // for autocomplete dropdown to render correctly
    maxWidth: "99%",
    "& > div": {
      marginBottom: 24
    }
  }
};
export default withStyles(styles)(Classification);
Classification.propTypes = {
  classes: PropTypes.object.isRequired,
  message: PropTypes.object.isRequired,
  messageResources: PropTypes.object.isRequired,
  isReadOnly: PropTypes.bool,
  aiReviewData: PropTypes.object,
  isAIDraftSelected: PropTypes.bool
};